import React from "react";
import { connect } from 'react-redux';
import ModalWrapper from '../../../atoms/modal-wrapper';
import ModalAddModule from '../modal-add-module';
import ModalAddIOIsland from "../modal-add-io-island";
import ModalConfirmation from '../modal-confirmation';
import ModalInformation from '../modal-information';
import ModalReplaceModule from '../modal-replace-module';
import ModalInsertModule from '../modal-insert-module';
import ModalDeviceAccessories from '../modal-device-accessory';
import ModalMarkdownReader from '../modal-markdown-reader';
import ModalIOTypes from '../modal-io-types';
import { closeModal } from '../ducks';
import ModalReplaceHeadModule from '../modal-replace-head-module';
import ModalPacdriveAdjust from '../modal-pacdrive-adjust';
import ModalSendEmail from '../modal-send-mail';
import ModalPreviewConfiguration from "../modal-preview-configuration";
import ModalMySchneiderLogin from "../modal-my-schneider-login";
import ModalSetRack from "../modal-set-rack";
import ModalPreviewPacConfiguration from "../modal-preview-pac-configuration";
import ModalPreviewEdgeConfiguration from "../modal-preview-edge-configuration";
import ModalHelpMeChoose from "../modal-help-me-choose";
import ModalSoftwareLicenceSelector from "../modal-software-licence-selector";
import ModalEdge3DViewer from "../modal-edge-3d-viewer";
import ModalEdgeFixationCover from "../modal-edge-fixation-cover";
import ModalAddRemoteArea from "../modal-add-remote-area";
import ModalCompareLicenseModels from "../modal-compare-license-models";
import ModalManagePacParameters from "../modal-manage-pac-parameters";

const MODAL_TYPES = {
  'add_module': ModalAddModule,
  'add_io_island' : ModalAddIOIsland,
  'add_remote_area': ModalAddRemoteArea,
  'confirmation': ModalConfirmation,
  'information': ModalInformation,
  'replace_module': ModalReplaceModule,
  'replace_head': ModalReplaceHeadModule,
  'insert_module': ModalInsertModule,
  'add_accessories': ModalDeviceAccessories,
  'markdown_reader': ModalMarkdownReader,
  'io_types': ModalIOTypes,
  'pacdrive-adjust': ModalPacdriveAdjust,
  'send-email': ModalSendEmail,
  'preview-configuration': ModalPreviewConfiguration,
  'preview-pac-configuration': ModalPreviewPacConfiguration,
  'preview-edge-configuration': ModalPreviewEdgeConfiguration,
  'my-schneider-login': ModalMySchneiderLogin,
  'set-rack': ModalSetRack,
  'help-me-choose': ModalHelpMeChoose,
  'software-licence-selector': ModalSoftwareLicenceSelector,
  'compare-license-models': ModalCompareLicenseModels,
  'edge-3d-viewer': ModalEdge3DViewer,
  'terminal-blocks-settings': ModalEdgeFixationCover,
  'manage-pac-parameters': ModalManagePacParameters
}

class ModalContainer extends React.PureComponent {

  closeModal = () => {
    this.props.closeModal();
  }

  render = () => {

    if (!this.props.modalType) {
      return null;
    }
    const SpecifiedModal = MODAL_TYPES[this.props.modalType];
    return (
      <React.Fragment>
        {this.props.modalProps.open &&
          <ModalWrapper>
            <SpecifiedModal
              closeModal={this.closeModal}
              toggleFilter={this.props.toggleFilter}
              {...this.props.modalProps}
              terminalBlockPreferences = { this.props.terminalBlockPreferences }
            >
            </SpecifiedModal>
          </ModalWrapper>
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return state.modal;
};

const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => dispatch(closeModal()),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
